// import React from "react";
// import "./HeroSection.css";
// import { Link } from "react-router-dom";
// import heroImage from "../../../asstes/Home/herobanner.png";
// import FloatingButton from "../../FloatingButton/FloatingButton";
// import RegisterButton from "../../RegisterProtect/RegisterButton";

// const HeroSection = () => {

//   return (
//     <div className="hero-wrapper">
//       {/* Background SVG */}

//       <div
//         className="hero-bg"
//         style={{ backgroundImage: `url(${heroImage})` }}
//       ></div>
//       {/* Hero Content */}
//       <div className="hero-section d-flex flex-column justify-content-center align-items-center text-center px-3">
//         <h1 className="hero-bg-text">
//           Engineers Againest Corrosion For
//           <br />
//           Certified Excellence
//           {/* Underline SVG */}
//           <svg
//             className="career-underline"
//             width="326"
//             height="40"
//             viewBox="0 0 326 40"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M4 4C55.0535 34.1559 145.148 57.5964 322 4"
//               stroke="url(#paint0_linear_568_395)"
//               stroke-width="7"
//               stroke-linecap="round"
//             />

//             <defs>
//               <linearGradient
//                 id="paint0_linear_568_395"
//                 x1="8"
//                 y1="20"
//                 x2="322"
//                 y2="20"
//                 gradientUnits="userSpaceOnUse"
//               >
//                 <stop stop-color="#111D2D" />
//                 <stop offset="1" stop-color="#14A4A8" />
//               </linearGradient>
//             </defs>
//           </svg>
//         </h1>
//         <p className="hero-paragraph">
//         Build your Global Career.
//         </p>

//         <div className="mt-4 d-flex gap-3 flex-wrap justify-content-center">
//           <button className="custom-viewhero-btn rounded-5 border-1 px-4">
//             <Link
//               to="/Courses"
//               style={{ textDecoration: "none", color: "#111D2D" }}
//             >
//               View Courses
//             </Link>
//           </button>

//           <RegisterButton
//             className="custom-register-home-btn border-0 rounded-5 px-5"
//           />
//         </div>
//       </div>
//       <FloatingButton />
//     </div>
//   );
// };

// export default HeroSection;


import React from "react";
import "./HeroSection.css";
import { Link } from "react-router-dom";
import heroImage from "../../../asstes/Home/herobanner.png";
import FloatingButton from "../../FloatingButton/FloatingButton";
import RegisterButton from "../../RegisterProtect/RegisterButton";

const HeroSection = () => {
  return (
    <div className="hero-wrapper">
      {/* Background SVG */}

      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${heroImage})` }}
      ></div>
      {/* Hero Content */}
      <div className="hero-section d-flex flex-column justify-content-center align-items-center text-center px-3">
        <h1 className="hero-bg-text">
           Engineers Againest Corrosion For
          <br />
          Certified Excellence
          {/* Underline SVG */}
          <svg
            className="career-underline"
            width="326"
            height="40"
            viewBox="0 0 326 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 4C55.0535 34.1559 145.148 57.5964 322 4"
              stroke="url(#paint0_linear_568_395)"
              stroke-width="7"
              stroke-linecap="round"
            />

            <defs>
              <linearGradient
                id="paint0_linear_568_395"
                x1="8"
                y1="20"
                x2="322"
                y2="20"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#111D2D" />
                <stop offset="1" stop-color="#14A4A8" />
              </linearGradient>
            </defs>
          </svg>
        </h1>
        <p className="hero-paragraph">
           Build your Global Career.
        </p>

        <div className="mt-4 d-flex gap-2 flex-wrap justify-content-center">
          <button className="custom-viewhero-btn rounded-5 border-1 px-4">
            <Link
              to="/Courses"
              style={{ textDecoration: "none", color: "#101727" }}
            >
              View Courses
            </Link>
          </button>

          <RegisterButton className="custom-register-home-btn border-0 rounded-5 px-4" />
        </div>
      </div>
      <FloatingButton />
    </div>
  );
};

export default HeroSection;
